import { useImpersonateWorkspace, Workspace } from '@gripp/shared-logic';
import { Pressable, StyleProp, StyleSheet, Text } from 'react-native';
import { Colors } from '../../themes';

type WorkspaceChipProps = {
  workspace: Workspace;
  additionalStyle?: StyleProp<any>;
};

export const ImpersonateWorkspaceChip = (props: WorkspaceChipProps) => {
  const { impersonateWorkspace } = useImpersonateWorkspace();

  const chipStyle = props.additionalStyle
    ? [styles.chip, props.additionalStyle]
    : [styles.chip];

  return (
    <Pressable
      onPress={async () => await impersonateWorkspace(props.workspace)}
      style={chipStyle}
    >
      <Text numberOfLines={1} style={[styles.chipText]} ellipsizeMode="tail">
        {props.workspace?.name}
      </Text>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  chip: {
    height: 28,
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    backgroundColor: Colors.primaryGrayBackground,
    paddingHorizontal: 8,
    borderRadius: 15,
  },
  chipText: {
    fontSize: 14,
    fontWeight: '500',
    letterSpacing: -0.3,
    color: Colors.black,
  },
});
